import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkAuth, authenticatedRequest } from '../utils/auth';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeDashboard = async () => {
      const isAuthenticated = await checkAuth();
      if (!isAuthenticated) {
        navigate('/');
        return;
      }
      setLoading(false);
    };
    
    initializeDashboard();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await authenticatedRequest('POST', '/logout');
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/');
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="loading">در حال بارگذاری...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-card">
        <div className="dashboard-header">
          <h2>پنل مدیریت</h2>
          <p>به پنل مدیریت خوش آمدید</p>
        </div>

        <div className="dashboard-actions">
          <div className="action-card" onClick={() => navigate('/import-menu')}>
            <h3>وارد کردن منو از اسنپ‌فود</h3>
            <p>استخراج و مدیریت منو از اسنپ‌فود</p>
          </div>
          <div className="action-card" onClick={() => navigate('/create-restaurant')}>
            <div className="action-icon">🏪</div>
            <h3>ایجاد رستوران</h3>
            <p>رستوران جدید اضافه کنید</p>
          </div>

          <div className="action-card" onClick={() => navigate('/create-offer')}>
            <div className="action-icon">🎯</div>
            <h3>ایجاد آفر</h3>
            <p>آفر جدید برای رستوران‌ها ایجاد کنید</p>
          </div>

          <div className="action-card" onClick={() => navigate('/offers-list')}>
            <div className="action-icon">📋</div>
            <h3>مدیریت آفرها</h3>
            <p>مشاهده و ویرایش آفرهای موجود</p>
          </div>

          <div className="action-card" onClick={() => navigate('/restaurants-list')}>
            <div className="action-icon">🗑️</div>
            <h3>مدیریت رستوران‌ها</h3>
            <p>مشاهده و حذف رستوران‌های موجود</p>
          </div>
        </div>

        <div className="dashboard-footer">
          <button onClick={handleLogout} className="logout-button">
            خروج از سیستم
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

